import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as Constants from '../Constants';
import { performLogout } from '../authLogout';
import NavbarSearch from './NavbarSearch';
import SessionTimeoutCountdown from './SessionTimeoutCountdown';
import { setSidebarIconOnlyPreference } from '../sidebarMode';

const hngLogo = require('../../assets/images/hng-logo.png');

class Navbar extends Component {
  state = {
    homepage : "/dashboard",
    username: localStorage.getItem('UserType') || "",
  }
  userTypeRoutes = Constants.USER_TYPE_ROUTES
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }
  gotoSettings = (e) => {
    e.preventDefault();
    this.props.history.push("/user-pages/settings")
  }

  logout = (e) => {
    e.preventDefault();
    performLogout(this.props.history);
  }

  toggleSidebarIconOnly = () => {
    const enabled = !document.body.classList.contains('sidebar-icon-only');
    setSidebarIconOnlyPreference(enabled);
  }

  toggleSidebarFromLogo = (e) => {
    e.preventDefault();
    this.toggleSidebarIconOnly();
  }

  componentDidMount() {
    const route = this.userTypeRoutes && this.userTypeRoutes[this.state.username] && this.userTypeRoutes[this.state.username][0]
    console.log(route)
    this.setState({homepage: route})
  }
  render () {
    return (
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row" >
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <Link className="navbar-brand brand-logo" to={this.state.homepage} onClick={this.toggleSidebarFromLogo}><img src={hngLogo} alt="HNGPL" /></Link>
          <Link className="navbar-brand brand-logo-mini" to={this.state.homepage} onClick={this.toggleSidebarFromLogo}><img src={hngLogo} alt="HNGPL" /></Link>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-stretch">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={this.toggleSidebarIconOnly}>
            <span className="mdi mdi-menu"></span>
          </button>
          <Link className="navbar-app-brand" to={this.state.homepage}>
            <img src={require('../../assets/images/Logo white bg.png')} alt="HNGPL" />
            <div className="navbar-app-brand-text">
              <span className="navbar-app-title">Haridwar Natural Gas</span>
              <span className="navbar-app-subtitle">Billing Software</span>
            </div>
          </Link>
          <div className="navbar-menu-tools d-flex align-items-stretch flex-grow-1">
          <NavbarSearch />
          <ul className="navbar-nav navbar-nav-right">
            <SessionTimeoutCountdown />
            <li className="nav-item nav-profile nav-language">
              <Dropdown alignRight>
                <Dropdown.Toggle className="nav-link count-indicator">
                  <div className="nav-profile-img">
                    <img src={require('../../assets/images/Logo white bg.png')} alt="profile" />
                  </div>
                  <div className="nav-profile-text">
                    <p className="mb-1 text-black" style={{textTransform : "uppercase"}}><Trans>{localStorage.getItem('Username') || "User"}</Trans></p>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="preview-list navbar-dropdown">
                  <div className="p-3 text-center bg-primary">
                    <img className="img-avatar img-avatar48 img-avatar-thumb" src={require('../../assets/images/Logo white bg.png')} alt=""/>
                  </div>
                  <div className="p-2">
                    <h5 className="dropdown-header text-uppercase pl-2 text-dark"><Trans>User Options</Trans></h5>
                    <Dropdown.Item className="dropdown-item d-flex align-items-center justify-content-between" href="!#" onClick={this.gotoSettings}>
                      <span><Trans>Change Password</Trans></span>
                      <i className="mdi mdi-settings"></i>
                    </Dropdown.Item>
                    <div role="separator" className="dropdown-divider"></div>
                    <h5 className="dropdown-header text-uppercase pl-2 text-dark mt-2"><Trans>Actions</Trans></h5>
                    <Dropdown.Item className="dropdown-item d-flex align-items-center justify-content-between" href="!#" onClick={this.logout}>
                      <span><Trans>Log Out</Trans></span>
                      <i className="mdi mdi-logout ml-1"></i>
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
          </div>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={this.toggleOffcanvas}>
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    );
  }
}

export default withRouter(Navbar);
